import React, { useEffect, useState, useRef, memo } from 'react';
import { isMobile, isIos } from '../../static/helper';
import './Items.scss';
import CircleProgressBar from '../CircleProgressBar/CircleProgressBar';


function Items(props) {
  const data = props.data[props.currentCategory];
  const currentSelected = props.selectedItems[props.currentCategory];
  const songsPlaying = useRef();
  const [progress, setProgress] = useState(null);
  const currentSongPlaying = useRef();

  const pauseAudio = (id) => {
    if (songsPlaying.current) {
      Object.keys(songsPlaying.current).map(item => {
        if (item == id) {
          if (songsPlaying.current[id].audio.paused) {
            songsPlaying.current[id].audio.play();
            currentSongPlaying.current = id;
            return;
          }
        }
        songsPlaying.current[item].audio.pause();
      })
    }
  }

  const playAudio = (id) => {
    let songsPlayingObj = { ...songsPlaying.current };
    let currentSong = songsPlayingObj[id];
    if (songsPlayingObj) {
      pauseAudio(id);
      if (currentSong)
        return;
    }
    document.querySelector("#audio-span").innerHTML = `<audio id="audio"><source src="${process.env.PUBLIC_URL}/${props.currentCategory}/${id}.mp3"></audio>`
    var audio = document.querySelector("#audio");
    songsPlayingObj[id] = { audio };
    songsPlaying.current = songsPlayingObj;
    audio.play();
    currentSongPlaying.current = id;
    audio.ontimeupdate = (e) => {
      let songsPlayingObj = { ...songsPlaying.current };
      let currentSong = songsPlayingObj[currentSongPlaying.current];
      currentSong.progress = { progress: ((e.currentTarget.currentTime / e.currentTarget.duration) * 100), duration: e.currentTarget.duration };
      songsPlaying.current = songsPlayingObj;
      setProgress({ progress: ((e.currentTarget.currentTime / e.currentTarget.duration) * 100), duration: e.currentTarget.duration });
    }
  }

  const getLentgh = (category) => {
    if (props.selectedItems[category])
      return props.selectedItems[category].length;
    return 0;
  }

  return (
    <div className={`items-wrapper page-${props.categoryIndex + 1}`}>
    {
      Object.keys(props.data).map((category, i) => (
        <div className={`items-page  ${props.currentCategory === category ? "display" : ""}`}>
        <div className={`items-container ${category}`}>
          {
            props.data[category] ?
            props.data[category].map((item, i) => {
                return (
                  <div className={`item ${category === props.currentCategory && currentSelected && currentSelected.some(x => x.id === item.id) ? "selected" : getLentgh(category) === 3 ? "black" : ""} ${songsPlaying.current && songsPlaying.current[item.id] && !songsPlaying.current[item.id].audio.paused ? `playing` : ""}`} onClick={(e) => props.setItem(item, e)}>
                    <div className="year">{item.year}</div>
                    <div className="img-container">
                      <img src={`${process.env.PUBLIC_URL}/images/items/${category}/${item.id}.jpg`} />
                    </div>
                    <div className="buttons">
                      <button className="add-desktop">בחירה</button>
                      <div className="add"></div>
                      {
                        category === "songs"
                          ?
                          <div className={`add play ${songsPlaying.current && songsPlaying.current[item.id] && !songsPlaying.current[item.id].audio.paused ? `playing` : ""}`} onClick={() => songsPlaying.current && songsPlaying.current[item.id] ? pauseAudio(item.id) : playAudio(item.id)}>
                            {
                              songsPlaying.current && songsPlaying.current[item.id] ?
                                <>
                                  <CircleProgressBar progress={songsPlaying.current[item.id].progress} />
                                </>
                                : ""
                            }
                          </div>
                          : ""
                      }
                    </div>
                    <div className="item-details">
                      {
                        item.singer ?
                            <>
                              <label className="name">{item.name}</label>
                              <label className="singer">{item.singer}</label>
                            </>
                          : <label className="name">{item.name}</label>
                      }

                      {/* <label className="name">{item.name}</label> */}
                    </div>
                  </div>
                )
              })
              : ""
          }
          </div>
        </div>
      ))
    }
    {
      props.currentCategory === "songs" ?
          <span id="audio-span"></span>
          : ""
    }

    </div>
  );
}

export default Items;
